import { render, staticRenderFns } from "./UserCenter.vue?vue&type=template&id=a8c00bf2&scoped=true"
import script from "./usercenter.js?vue&type=script&lang=js&external"
export * from "./usercenter.js?vue&type=script&lang=js&external"
import style0 from "./usercenter.scss?vue&type=style&index=0&id=a8c00bf2&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8c00bf2",
  null
  
)

export default component.exports